import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import { GET_EMPLOYEE_INBODY_OPTIONS, GET_EMPLOYEE_INBODY_RESULT, GET_EMPLOYEE_INBODY_RESULT_PAGE } from "@Apis/apiPath";

const useEmployeeInbodyApi = () => {
    const Axios = useAxios();

    const getEmployeeInbodyOptionsApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_EMPLOYEE_INBODY_OPTIONS);
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getEmployeeInbodyResultApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_EMPLOYEE_INBODY_RESULT(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    const getEmployeeInbodyResultPageApi = useCallback(
        async (measureID) => {
            const resp = await Axios.get(GET_EMPLOYEE_INBODY_RESULT_PAGE(measureID));
            return resp;
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getEmployeeInbodyOptionsApi,
        getEmployeeInbodyResultApi,
        getEmployeeInbodyResultPageApi,
    };
};

export default useEmployeeInbodyApi;

    